import {
  BulkSelectionState,
  IFloorplanLayers,
  SpaceShapeVM,
} from 'spw-redux/modules/floorplan/types';
import * as constants from 'spw-constants';
import {
  PRIVATE_OFFICES_SUBCATEGORY,
  WORKSTATIONS_SUBCATEGORY,
} from 'spw-constants';

const {
  INDIVIDUAL_SPACES_CATEGORY,
  MEETING_SPACES_CATEGORY,
  AMENITY_SPACES_CATEGORY,
  SUPPORT_SPACES_CATEGORY,
  CUSTOM_SUBCATEGORY,
  CUSTOM_CATEGORY,
} = constants;

export const buildSpacesCSSClasses = (layers: IFloorplanLayers) => ({
  [INDIVIDUAL_SPACES_CATEGORY]: {
    cssClass: 'individual-space',
    layer: layers.individualSpacesLayer,
  },
  [WORKSTATIONS_SUBCATEGORY]: {
    cssClass: 'individual-space',
    layer: layers.individualSpacesLayer,
  },
  [PRIVATE_OFFICES_SUBCATEGORY]: {
    cssClass: 'individual-space',
    layer: layers.individualSpacesLayer,
  },
  [CUSTOM_SUBCATEGORY]: {
    cssClass: 'individual-space',
    layer: layers.individualSpacesLayer,
  },
  [MEETING_SPACES_CATEGORY]: {
    cssClass: 'meeting-space',
    layer: layers.meetingSpacesLayer,
  },
  [AMENITY_SPACES_CATEGORY]: {
    cssClass: 'amenity-space',
    layer: layers.amenitySpacesLayer,
  },
  [SUPPORT_SPACES_CATEGORY]: {
    cssClass: 'support-space',
    layer: layers.supportSpacesLayer,
  },
  [CUSTOM_CATEGORY]: {
    cssClass: 'other-space',
    layer: layers.customSpacesLayer,
  },
});

export type AnchorElementPosition = {
  left?: number;
  top: number;
};

export const getPositionFromAnchorElement = (
  anchorElement: Element,
  offset = { left: 0, top: 0 }
): AnchorElementPosition => {
  const boundingRect = anchorElement.getBoundingClientRect();

  return {
    left: boundingRect.left + offset.left,
    top: boundingRect.top + offset.top,
  };
};

export const calculateBoundsArea = (bounds: L.Bounds): number =>
  bounds.getSize().x * bounds.getSize().y;

export const shouldOpenConfirmExitFloorplanOperationPrompt = (
  bulkSelectionState: BulkSelectionState,
  floorUsfShapeToCopy?: SpaceShapeVM
) => {
  return (
    [
      BulkSelectionState.SELECTION,
      BulkSelectionState.DRAWING,
      BulkSelectionState.COPY,
      BulkSelectionState.MOVE,
      BulkSelectionState.ROTATE,
    ].includes(bulkSelectionState) || Boolean(floorUsfShapeToCopy)
  );
};
